import React from 'react';
export var FormContext = React.createContext(undefined);


//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/grommet/es6/components/Form/FormContext.js
// module id = 142
// module chunks = 2